<div *ngIf="show" id="cover-spin">
<div class="loadingImg"><img src="{{ cdnUrl }}/assets/images/loading.gif" width="50"/><br/> Please Wait...</div>
</div>